import axios from 'axios'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { SButton } from './common/BCommonComponents';
import { useHistory } from 'react-router-dom';
import { Dialog, DialogActions, DialogContent, FormControl, Grid, IconButton, MenuItem, Paper, Select, Table, TableBody, TableContainer } from '@material-ui/core';

type VerificaEmailParameters = {
    code?: string
}
export const VerificaEmail = () => {

    const history = useHistory();
    const param = useParams<VerificaEmailParameters>();
    const [emailVerified, setEmailVerified] = useState<boolean>(false);
    const [responseOk, setResponseOk] = useState<boolean>(false);
    useEffect(() => {
        const tokenVerifica = {
            emailToVerify: param.code
        }
        axios.post('/api/email/verifica-email', tokenVerifica)
            .then(res => {
                if (res.data) {
                    toast.success("Email verificata con successo!")
                    setEmailVerified(true);
                } else {
                    toast.error("🛑 Non è stato possibile verificare l'indirizzo email");
                }
                setResponseOk(true);
            })
            .catch(error => {
                toast.error("🛑 Errore durante la verifica dell'email");
                console.log(error);
            });

    });

    const handleGoLogin = () => {
        history.push("/login");
    }

    return (
        <div style={{ width: '100%' }}>
            {emailVerified && responseOk &&
              <Grid container spacing={0} className="w-100 my-4 align-items-center">
                  <Grid item xs={12} className="w-100" style={{ textAlign: "center" }}>
                      <p>Email verificata con successo! Effettua l'accesso.</p>
                  </Grid>
                  <Grid item xs={12} className="w-100" style={{ textAlign: "center", justifyContent: "center", display: "flex" }}>
                      <SButton onClick={handleGoLogin}>
                          Accedi
                      </SButton>
                  </Grid>
              </Grid>
            }
            {!emailVerified && responseOk &&
              <Grid container spacing={0} className="w-100 my-4 align-items-center">
                  <Grid item xs={12} className="w-100" style={{ textAlign: "center" }}>
                      <p>Non è stato possibile verificare il tuo indirizzo email. Effettua di nuovo l'accesso e riprova ad inviare la mail di verifica.</p>
                  </Grid>
                  <Grid item xs={12} className="w-100" style={{ textAlign: "center", justifyContent: "center", display: "flex" }}>
                      <SButton onClick={handleGoLogin}>
                          Accedi
                      </SButton>
                  </Grid>
              </Grid>
            }
        </div>
    )
}

export default VerificaEmail